import { STATUS_PRIORITY } from "./constant";

export const statusSortFunc = (a, b, order, dataField, rowA, rowB) => {
    const getPriority = (status) => {
        return STATUS_PRIORITY[status] !== undefined ? STATUS_PRIORITY[status] : 100;
    };

    const priorityA = getPriority(rowA.campaignstatus);
    const priorityB = getPriority(rowB.campaignstatus);

    if (priorityA !== priorityB) {
        if (order === 'asc') {
            return priorityA - priorityB;
        } else {
            return priorityB - priorityA;
        }
    }
    
    const countA = rowA.numbersUploaded;
    const countB = rowB.numbersUploaded;
    
    return countB - countA;
};

export const convertToAMPM = (timeString) => {
  if (!timeString) return '';
  
  const timePart = timeString.includes(' ') ? timeString.split(' ')[1] : timeString;
  
  let [hours, minutes] = timePart.split(':');
  
  hours = parseInt(hours, 10);
  minutes = parseInt(minutes, 10);
  
  const ampm = hours >= 12 ? 'PM' : 'AM';
  
  hours = hours % 12;
  hours = hours ? hours : 12;
  
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  
  return `${hours}:${minutes} ${ampm}`;
};

export const parseCurl = (curl) => {
    try {
        if (!curl || typeof curl !== "string") {
            return { url: "", method: "GET", headers: {}, body: "" };
        }

        // --- CLEANUP INVISIBLE CHARACTERS ---
        curl = curl
            .replace(/\u00A0/g, " ")   // Non-breaking space
            .replace(/\u200B/g, "")    // Zero-width space
            .replace(/\s{2,}/g, " ")   // Compress multiple spaces
            .replace(/\\\r?\n/g, " ")  // Join multiline
            .trim();

        // Extract URL
        let urlMatch = curl.match(/(https?:\/\/[^\s'"]+)/i);
        let url = urlMatch ? urlMatch[1] : "";

        // --- REMOVE TRAILING QUOTES OR %27 SAFELY ---
        if (url) {
            // Only remove if at the very end
            url = url.replace(/(['%27]+)$/g, '');
            // Decode URL to make it human-readable
            try {
                url = decodeURIComponent(url);
            } catch (e) {
                // If decoding fails, leave as-is
            }
        }

        // Extract method from -X
        let method = "GET";
        const methodMatch = curl.match(/-X\s+(\w+)/i);
        if (methodMatch) method = methodMatch[1].toUpperCase();

        // Force GET if -G flag exists
        if (/\s-G\s/.test(curl)) method = "GET";

        // Default to POST if data exists and no explicit method
        const hasDataFlag = /\s(--data|-d|--data-raw|--data-binary|--form|-F|--data-urlencode)\s+/.test(curl);
        if (!methodMatch && !/\s-G\s/.test(curl) && hasDataFlag) method = "POST";

        // Extract headers (-H, --header)
        const headers = {};
        const headerMatches = [...curl.matchAll(/(?:-H|--header)\s+['"]?([^'"\n]+)['"]?/gi)];
        headerMatches.forEach((m) => {
            const headerLine = m[1].trim();
            const [key, ...rest] = headerLine.split(":");
            if (key && rest.length) headers[key.trim()] = rest.join(":").trim();
        });

        // Extract body (supports multiple flags)
        const dataFlags = ["-d", "--data", "--data-raw", "--data-binary", "--form", "-F"];
        let body = "";

        for (const flag of dataFlags) {
            // Quoted body
            const matchQuoted = curl.match(new RegExp(`${flag}\\s+(['"])([\\s\\S]*?)\\1`));
            if (matchQuoted) {
                body = matchQuoted[2].trim();
                break;
            }
            // Unquoted body
            const matchUnquoted = curl.match(new RegExp(`${flag}\\s+([^\\s]+)`));
            if (matchUnquoted) {
                body = matchUnquoted[1].trim();
                break;
            }
        }

        // Handle --data-urlencode (multiple occurrences)
        const params = [];
        const urlEncodeRegex = /--data-urlencode\s+(?:'([^']+)'|"([^"]+)"|([^\s]+))/gi;
        let encoded;
        while ((encoded = urlEncodeRegex.exec(curl)) !== null) {
            const param = encoded[1] || encoded[2] || encoded[3]; // pick whichever matched
            params.push(param.trim());
        }

        // Append encoded params to URL if GET
        if (method === "GET" && params.length) {
            const query = params.join("&");
            url += (url.includes("?") ? "&" : "?") + query;
        }

        // Parse the body as JSON to preserve data types
        let parsedBody = body;
        if (body && method !== "GET") {
            try {
                // Try to parse as JSON to preserve data types
                parsedBody = JSON.parse(body);
                // Convert back to string with proper formatting
                body = JSON.stringify(parsedBody);
            } catch (e) {
                // If not valid JSON, keep as is
            }
        }

        return { url, method, headers, body };
    } catch (error) {
        console.error("Error parsing curl:", error);
        return { url: "", method: "GET", headers: {}, body: "" };
    }
};

export const convertArrayToString = (headersArray) => {
    const hasValidHeaders = headersArray.some(param => 
        param.key && param.key.trim() !== ''
    );
    
    if (!hasValidHeaders) {
        return '';
    }
    
    const headersObj = headersArray.reduce((acc, { key, value }) => {
        if (key && key.trim() !== '') {
            acc[key] = value || ''; 
        }
        return acc;
    }, {});
    const cleanJson=parseNestedStrings(headersObj)
    return JSON.stringify(cleanJson, null, 2);
};

export const convertStringToArray = (headersString) => {
    if (!headersString || headersString.trim() === '') {
        return [{ key: "", value: "" }];
    }
    
    try {
        const headersObj = JSON.parse(headersString);
        return Object.keys(headersObj).map(key => ({
            key,
            value: (headersObj[key] && typeof headersObj[key] === 'object' && !Array.isArray(headersObj[key]))
                ? JSON.stringify(headersObj[key])
                : headersObj[key]
        }));
    } catch (e) {
        console.error('Error parsing headers string:', e);
        return [{ key: "", value: "" }];
    }
}
export const syntaxHighlight = (json) => {
    if (typeof json !== "string") {
        json = JSON.stringify(json, null, 2);
    }
    json = json
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(
            /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|\b-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?\b)/g,
            (match) => {
                let cls = "number";
                if (/^"/.test(match)) {
                    if (/:$/.test(match)) {
                        cls = "key";
                    } else {
                        cls = "string";
                    }
                } else if (/true|false/.test(match)) {
                    cls = "boolean";
                } else if (/null/.test(match)) {
                    cls = "null";
                }
                return `<span class="${cls}">${match}</span>`;
            }
        );
    return json;
};

export function isExpired(expiryDate) {
    if (!expiryDate) return false;
    const exp = new Date(expiryDate.replace(" ", "T"));
    return exp < new Date();
}

export function parseNestedStrings(obj) {
    if (typeof obj === "string") {
        const trimmed = obj.trim();
        if (!(trimmed.startsWith("{") || trimmed.startsWith("["))) {
            return obj; 
        }
        try {
            const parsed = JSON.parse(trimmed);
            return parseNestedStrings(parsed);
        } catch {
            return obj;
        }
    }

    if (Array.isArray(obj)) {
        return obj.map(parseNestedStrings);
    }

    if (obj && typeof obj === "object") {
        return Object.fromEntries(
            Object.entries(obj).map(([k, v]) => [k, parseNestedStrings(v)])
        );
    }

    return obj;
}
